var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.259,
    height: 28.602,
    viewBox: "0 0 24.259 28.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13303",
    "data-name": "Group 13303",
    transform: "translate(-326.997 -521.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6063",
    "data-name": "Path 6063",
    d: "M21.928,25.8H20.746a1,1,0,1,1,0-2h1.182a.755.755,0,0,0,.754-.754V12.973a1,1,0,0,1,1-1h2.178a.344.344,0,0,0,.243-.587L16.319,1.6a.344.344,0,0,0-.486,0L6.049,11.385a.344.344,0,0,0,.244.587H7.751a1,1,0,0,1,1,1V23.048a.755.755,0,0,0,.754.754h5.12a1,1,0,0,1,0,2H9.505a2.757,2.757,0,0,1-2.754-2.754V13.973H6.292a2.344,2.344,0,0,1-1.658-4L14.419.187a2.344,2.344,0,0,1,3.315,0l9.784,9.784a2.344,2.344,0,0,1-1.657,4H24.682v9.075A2.757,2.757,0,0,1,21.928,25.8Z",
    transform: "translate(323.05 521.527)",
    fill: "#157fee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6065",
    "data-name": "Path 6065",
    d: "M25.6,37.78a1,1,0,0,1-1-.98c0-.012-.024-1.208-.036-2.4-.006-.59-.008-1.083-.007-1.47H20.1a2.311,2.311,0,0,1-2.309-2.309v-.04A2.311,2.311,0,0,1,20.1,28.273h6.836a.293.293,0,1,0,0-.585H20.1a2.308,2.308,0,1,1,0-4.617H22.91V21.089a1,1,0,0,1,2,0v2.982a1,1,0,0,1-1,1H20.1a.308.308,0,1,0,0,.617h6.836A2.311,2.311,0,0,1,29.238,27.9q0,.031,0,.062V28q0,.031,0,.062a2.311,2.311,0,0,1-2.307,2.214H20.1a.309.309,0,0,0-.309.309v.04a.309.309,0,0,0,.309.309h5.5a.081.081,0,0,0,.016,0,1,1,0,0,1,.955,1.238c-.03.486-.01,2.661.028,4.593a1,1,0,0,1-.98,1.02Z",
    transform: "translate(315.211 511.849)",
    fill: "#157fee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6066",
    "data-name": "Path 6066",
    d: "M29.873,20.382a1,1,0,0,1-.707-.293l-1.621-1.621L25.925,20.09a1,1,0,1,1-1.414-1.414l2.328-2.328a1,1,0,0,1,1.414,0l2.328,2.328a1,1,0,0,1-.707,1.707Z",
    transform: "translate(311.558 513.793)",
    fill: "#157fee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatPump);
export default __webpack_public_path__ + "static/media/heatPump.2fc52d82e377dfcd72b944a5661db216.svg";
export { ForwardRef as ReactComponent };